import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createPartnerEventAsync, getPartnerEventDetailsAsync, getPartnerEventMonthlyAsync, updatePartnerEventAsync } from './partnerEventThunk';
const initialState = {
    status: APIStatus.IDLE,
};
export const PartnerEventSlice = createSlice({
    name: 'PartnerEvent',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Handle createPartnerEventAsync
        builder
            .addCase(createPartnerEventAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPartnerEventAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.PartnerEvent = action.payload;
        })
            .addCase(createPartnerEventAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updatePartnerEventAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePartnerEventAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.PartnerEvent = action.payload;
        })
            .addCase(updatePartnerEventAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPartnerEventMonthlyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPartnerEventMonthlyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.MonthlyPartnerEvent = action.payload;
        })
            .addCase(getPartnerEventMonthlyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPartnerEventDetailsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPartnerEventDetailsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.PartnerEventDetails = action.payload;
        })
            .addCase(getPartnerEventDetailsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default PartnerEventSlice.reducer;
